import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  EmailSubscriptionStatus,
  UserSubscriptionView,
} from "../../../models/email-subscription.model";
import { Url } from "../Url";

export interface SubscriptionUpdate {
  topicId: number;
  status: EmailSubscriptionStatus;
}

@Injectable({ providedIn: "root" })
export class EmailsService {
  private apiUrl = Url;

  constructor(private httpClient: HttpClient) {}

  getSubscriptions(): Observable<UserSubscriptionView[]> {
    return this.httpClient.get<UserSubscriptionView[]>(
      `${this.apiUrl}/emails/subscriptions`,
    );
  }

  /**
   * Whether the authed grower/entity was auto-enrolled in any email at signup.
   * Used by the welcome modal to decide whether to show the enrollment note.
   */
  hasSignupDefault(): Observable<boolean> {
    return this.httpClient.get<boolean>(
      `${this.apiUrl}/emails/subscriptions/has-signup-default`,
    );
  }

  updateSubscriptions(
    updates: SubscriptionUpdate[],
  ): Observable<UserSubscriptionView[]> {
    return this.httpClient.patch<UserSubscriptionView[]>(
      `${this.apiUrl}/emails/subscriptions`,
      { updates },
    );
  }
}
